export const environment = {
    production: true,
    appVersion: 'v0.0.1',

    URL_KEY_CLOACK: 'https://dev-sso.scrd.gov.co/auth/',
    REALM: 'SCRD',
    CLIENT_ID: 'impulso-front',
    PERFIL_USUARIO: 'https://dev-sso.scrd.gov.co/auth/realms/SCRD/account/',
    REDIRECT_URI: 'https://dev-sso.scrd.gov.co/auth/realms/SCRD/protocol/openid-connect/auth?client_id=impulso-front&redirect_uri=https://dev-nuevo-ecosistema-cultural.scrd.gov.co/admin/dashboard&response_type=code&scope=openid',


    UPDATE_TOKEN_TIME: 20,

    URL_API_GEO: 'https://geopandora.idartes.gov.co/api/v1/barrios',

    urlsApi: {
        transversal: 'https://dev-transversal-impulso.scrd.gov.co/api/v1',
        eventos: 'https://dev-eventos-impulso.scrd.gov.co/api/v1',
        artistas: 'https://dev-individuos-impulso.scrd.gov.co/api/v1',
        gateway: 'http://190.26.196.147/api',
        empresas: 'https://dev-publico-impulso.scrd.gov.co/api/v1',
        collective: 'https://dev-educativo-impulso.scrd.gov.co/api/v1',
        ciudadano: 'http://190.26.196.147/ciudadano/api/v1',
        espacios: 'https://dev-grupal-impulso.scrd.gov.co/api/v1',
        medios: 'http://190.26.196.147/medios/api/v1',
       lenguaje:'https://gestion.cultured.gov.co/api/apiPandora/parameters',
    },

    API_KEY_GEO: 'pk.5383e9fb4b08c7783919c3ca31d504f1',
    API_KEY_IDECA: '1fd54084-e295-4960-829e-c5caa3658f80',

    //Metronic
    USERDATA_KEY: 'authf649fc9a5f55',
    isMockEnabled: true,
    apiUrl: 'api',
    appThemeName: 'Metronic',
    appPurchaseUrl: 'https://1.envato.market/EA4JP',
    appHTMLIntegration: 'https://preview.keenthemes.com/metronic8/demo1/documentation/base/helpers/flex-layouts.html',
    appPreviewUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1/',
    appPreviewAngularUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1',
    appPreviewDocsUrl: 'https://preview.keenthemes.com/metronic8/angular/docs',
    appPreviewChangelogUrl: 'https://preview.keenthemes.com/metronic8/angular/docs/changelog',
    appDemos: {
        demo1: {
            title: 'Demo 1',
            description: 'Default Dashboard',
            published: true,
            thumbnail: './assets/media/demos/demo1.png',
        },

        demo2: {
            title: 'Demo 2',
            description: 'SaaS Application',
            published: true,
            thumbnail: './assets/media/demos/demo2.png',
        },

        demo3: {
            title: 'Demo 3',
            description: 'New Trend',
            published: true,
            thumbnail: './assets/media/demos/demo3.png',
        },

        demo4: {
            title: 'Demo 4',
            description: 'Intranet Application',
            published: true,
            thumbnail: './assets/media/demos/demo4.png',
        },

        demo5: {
            title: 'Demo 5',
            description: 'Support Forum',
            published: false,
            thumbnail: './assets/media/demos/demo5.png',
        },

        demo6: {
            title: 'Demo 6',
            description: 'Admin Backend',
            published: true,
            thumbnail: './assets/media/demos/demo6.png',
        },

        demo7: {
            title: 'Demo 7',
            description: 'CRM Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo7.png',
        },

        demo8: {
            title: 'Demo 8',
            description: 'Core Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo8.png',
        },

        demo9: {
            title: 'Demo 9',
            description: 'Fancy Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo9.png',
        },

        demo10: {
            title: 'Demo 10',
            description: 'Modern Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo10.png',
        },

        demo11: {
            title: 'Demo 11',
            description: 'Light Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo11.png',
        },

        demo12: {
            title: 'Demo 12',
            description: 'Reporting System',
            published: false,
            thumbnail: './assets/media/demos/demo12.png',
        },

        demo13: {
            title: 'Demo 13',
            description: 'Classic Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo13.png',
        },

        demo14: {
            title: 'Demo 14',
            description: 'Creative Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo14.png',
        },

        demo15: {
            title: 'Demo 15',
            description: 'Minimalistic Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo15.png',
        },

        demo16: {
            title: 'Demo 16',
            description: 'Modern Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo16.png',
        },

        demo17: {
            title: 'Demo 17',
            description: 'Backend System',
            published: false,
            thumbnail: './assets/media/demos/demo17.png',
        },

        demo18: {
            title: 'Demo 18',
            description: 'System Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo18.png',
        },

        demo19: {
            title: 'Demo 19',
            description: 'Light Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo19.png',
        },

        demo20: {
            title: 'Demo 20',
            description: 'Monochrome Dashboard',
            published: false,
            thumbnail: './assets/media/demos/demo20.png',
        },
    },
};
